import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  cancelTicketAPIHelper,
  deleteEventAPIHelper,
  deleteFeedAPIHelper,
  deleteFeedCommentAPIHelper,
  deleteFeedCommentReplayAPIHelper,
  deleteVolunteerByIdAPIHelper,
  getAttendeeAccessAPIHelper,
  getEventAccessLogsAPIHelper,
  getEventAnalyticsAPIHelper,
  getEventAttendeesAPIHelper,
  getEventsAPIHelper,
  getExploreAllAPIHelper,
  getFeedCommentAPIHelper,
  getFeedsAPIHelper,
  getInviatedUsersEventAPIHelper,
  getMyFeedsAPIHelper,
  getRegisteredEventAPIHelper,
  getRegisteredEventHistoryAPIHelper,
  getSingleEventAPIHelper,
  getSingleFeedAPIHelper,
  getVolunteerByIdAPIHelper,
  getVolunteersAPIHelper,
  likeFeedAPIHelper,
  PatchAttendeeAccessAPIHelper,
  postEventAPIHelper,
  postFeedAPIHelper,
  postFeedCommentAPIHelper,
  postFeedCommentReplayAPIHelper,
  postInviteUserstoEventAPIHelper,
  postVolunteerAPIHelper,
  registerForEventAPIHelper,
  removeUsersFromInviteListAPIHelper,
  transferTicketAPIHelper,
  updateEventAPIHelper,
  updateFeedAPIHelper,
  updateFeedCommentAPIHelper,
  updateFeedCommentLikeAPIHelper,
  updateFeedCommentReplayAPIHelper,
  updateFeedCommentReplayLikeAPIHelper,
} from "../helpers/communityAPI";

const initialState = {
  singleFeed: {},
  feeds: {   // Changed to object with data and pagination
    data: [],
    pagination: null
  },
  myFeeds: [],
  comments: [],
  events: [],
  singleEvent: [],
  myEvents: {  // ✅ Proper structure
    data: [],
    pagination: null
  },
  EventAttendees: [],
  registeredAttendees: [],
  registeredAttendeesHistory: [],
  attendeeAcessPass: [],
  exploreAllFeeds: [],
  getInviteUserEvent: [],
  loadingFeeds: false,
  exploreType: "PROFESSIONAL",
  eventAnalytics: [],
  VolunteersData: [],
  VolunteerByIdData: [],
  geteventaccessbyId: [],
};

// Feed API's
export const getFeeds = createAsyncThunk(
  "/community/feeds",
  async (params, thunkAPI) => {
    try {
      const response = await getFeedsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getMyFeeds = createAsyncThunk(
  "/community/my-feeds",
  async (params, thunkAPI) => {
    try {
      const response = await getMyFeedsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getSingleFeed = createAsyncThunk(
  "/community/feed",
  async (id, thunkAPI) => {
    try {
      const response = await getSingleFeedAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postFeed = createAsyncThunk(
  "/community/post-feed",
  async (payload, thunkAPI) => {
    try {
      const response = await postFeedAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateFeed = createAsyncThunk(
  "/community/update-feed",
  async (payload, thunkAPI) => {
    try {
      const response = await updateFeedAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteFeed = createAsyncThunk(
  "/community/delete-feed",
  async (id, thunkAPI) => {
    try {
      const response = await deleteFeedAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const likeFeed = createAsyncThunk(
  "/community/like-feed",
  async (id, thunkAPI) => {
    try {
      const response = await likeFeedAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postFeedComment = createAsyncThunk(
  "/post/post-feed-comment",
  async (params, thunkAPI) => {
    try {
      const response = await postFeedCommentAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getFeedComment = createAsyncThunk(
  "/post/get-feed-comment",
  async (params, thunkAPI) => {
    try {
      const response = await getFeedCommentAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateFeedComment = createAsyncThunk(
  "/post/update-feed-comment",
  async (params, thunkAPI) => {
    try {
      const response = await updateFeedCommentAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteFeedComment = createAsyncThunk(
  "/post/delete-feed-comment",
  async (params, thunkAPI) => {
    try {
      const response = await deleteFeedCommentAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postFeedCommentReplay = createAsyncThunk(
  "/post/post-feed-comment-replay",
  async (params, thunkAPI) => {
    try {
      const response = await postFeedCommentReplayAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateFeedCommentReplay = createAsyncThunk(
  "/post/update-feed-comment-replay",
  async (params, thunkAPI) => {
    try {
      const response = await updateFeedCommentReplayAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteFeedCommentReplay = createAsyncThunk(
  "/post/delete-feed-comment-replay",
  async (params, thunkAPI) => {
    try {
      const response = await deleteFeedCommentReplayAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateFeedCommentLikes = createAsyncThunk(
  "/post/update-feed-comment-likes",
  async (params, thunkAPI) => {
    try {
      const response = await updateFeedCommentLikeAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateFeedCommentReplayLikes = createAsyncThunk(
  "/post/update-feed-comment-Replay-likes",
  async (params, thunkAPI) => {
    try {
      const response = await updateFeedCommentReplayLikeAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const postEvent = createAsyncThunk(
  "/community/post-evet",
  async (payload, thunkAPI) => {
    try {
      const response = await postEventAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateEvent = createAsyncThunk(
  "/community/update-evet",
  async (payload, thunkAPI) => {
    try {
      const response = await updateEventAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getAllEvents = createAsyncThunk(
  "/community/get-All-events",
  async (params, thunkAPI) => {
    try {
      const response = await getEventsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getMyEvents = createAsyncThunk(
  "/community/get-My-events",
  async (params, thunkAPI) => {
    try {
      const response = await getEventsAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getSingleEvent = createAsyncThunk(
  "/community/get-single-event",
  async (id, thunkAPI) => {
    try {
      const response = await getSingleEventAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteEvent = createAsyncThunk(
  "/community/delete-event",
  async (id, thunkAPI) => {
    try {
      const response = await deleteEventAPIHelper(id);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const RegisterEvent = createAsyncThunk(
  "/community/register-evet",
  async (params, thunkAPI) => {
    try {
      const response = await registerForEventAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);

export const getEventAttendees = createAsyncThunk(
  "/post/get-Event-attendees",
  async (eventId, thunkAPI) => {
    try {
      const response = await getEventAttendeesAPIHelper(eventId);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getRegisteredAttendees = createAsyncThunk(
  "/post/get-registered-attendees",
  async (params, thunkAPI) => {
    try {
      const response = await getRegisteredEventAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getRegisteredAttendeesHistory = createAsyncThunk(
  "/post/get-registered-attendees-history",
  async (params, thunkAPI) => {
    try {
      const response = await getRegisteredEventHistoryAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getAttendeeAccessPass = createAsyncThunk(
  "/post/get-attendee-access-pass",
  async (ticketId, thunkAPI) => {
    try {
      const response = await getAttendeeAccessAPIHelper(ticketId);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const patchAttendeeAccessPass = createAsyncThunk(
  "/patch/patch-attendee-access-pass",
  async (payload, thunkAPI) => {
    try {
      const response = await PatchAttendeeAccessAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const transferTicket = createAsyncThunk(
  "/post/transfer-ticket",
  async (payload, thunkAPI) => {
    try {
      const response = await transferTicketAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const cancelTicket = createAsyncThunk(
  "/post/cancel-ticket",
  async (payload, thunkAPI) => {
    try {
      const response = await cancelTicketAPIHelper(payload);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getExplore = createAsyncThunk(
  "/post/get-explore",
  async (params, thunkAPI) => {
    try {
      const response = await getExploreAllAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const PostInvaiteUsersToEvent = createAsyncThunk(
  "/post/post-Invaite-to-event",
  async (params, thunkAPI) => {
    try {
      const response = await postInviteUserstoEventAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const removeUsersFromInvaite = createAsyncThunk(
  "/community/remove-Users-From-Invaite",
  async (params, thunkAPI) => {
    try {
      const response = await removeUsersFromInviteListAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const getInvaiteUsersEvent = createAsyncThunk(
  "/post/get-Invaite-Users-event",
  async (params, thunkAPI) => {
    try {
      const response = await getInviatedUsersEventAPIHelper(params);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// ================= VOLUNTEER APIS =================

export const getEventAnalytics = createAsyncThunk(
  '/events/analytics',
  async (id, thunkAPI) => {
    try {
      const response = await getEventAnalyticsAPIHelper(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getEventAccessLogs = createAsyncThunk(
  '/events/access-logs',
  async (params, thunkAPI) => {
    try {
      const response = await getEventAccessLogsAPIHelper(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const postVolunteer = createAsyncThunk(
  '/volunteers/post-volunteers',
  async (payload, thunkAPI) => {
    try {
      const response = await postVolunteerAPIHelper(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getVolunteers = createAsyncThunk(
  '/volunteers/get-volunteers',
  async (eventId, thunkAPI) => {
    try {
      const response = await getVolunteersAPIHelper(eventId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
)

export const getVolunteerById = createAsyncThunk(
  '/voulunteers/get-voulunteer-id',
  async (params, thunkAPI) => {
    try {
      const response = await getVolunteerByIdAPIHelper(params);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const deleteVolunteer = createAsyncThunk(
  '/voulunteers/delete-volunteer',
  async (id, thunkAPI) => {
    try {
      const response = await deleteVolunteerByIdAPIHelper(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);




const communitySlice = createSlice({
  name: "community",
  initialState,
  reducers: {
    setFeeds: (state, action) => {
      state.feeds = action.payload;
    },
    setExploreType: (state, action) => {
      state.exploreType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeeds.pending, (state) => {
        state.loadingFeeds = true;
      })
      .addCase(getFeeds.fulfilled, (state, action) => {
        console.log("action pending get my feeds api");
        state.feeds = action?.payload;
      })
      .addCase(getFeeds.rejected, (state) => {
        state.loadingFeeds = false;
      })
      .addCase(getMyFeeds.pending, (state, action) => {
        console.log("action pending get my feeds api");
      })
      .addCase(getMyFeeds.fulfilled, (state, action) => {
        const page = action.payload.pagination?.page;
        state.feeds = {
          data: page > 0
            ? [...state.feeds.data, ...action.payload.data]
            : action.payload.data,
          pagination: action.payload.pagination,
          loading: false
        };
      })
      .addCase(getMyFeeds.rejected, (state, action) => {
        console.log("action rejected get my feeds api", action?.payload);
      })
      .addCase(getFeedComment.pending, (state, action) => {
        console.log("action pending get my feeds api");
      })
      .addCase(getFeedComment.fulfilled, (state, action) => {
        console.log("action fulfilled get my feeds api");
        state.comments = action?.payload?.data;
      })
      .addCase(getFeedComment.rejected, (state, action) => {
        console.log("action rejected get my feeds api", action?.payload);
      })
      .addCase(getSingleFeed.pending, (state, action) => {
        console.log("action pending get single feeds api");
      })
      .addCase(getSingleFeed.fulfilled, (state, action) => {
        console.log("action fulfilled get single feeds api");
        state.singleFeed = action?.payload?.data;
      })
      .addCase(getSingleFeed.rejected, (state, action) => {
        console.log("action rejected get single feed api", action?.payload);
      })
      .addCase(postFeed.pending, (state, action) => {
        console.log("action pending post feed api");
      })
      .addCase(postFeed.fulfilled, (state, action) => {
        console.log("action fulfilled post feed api");
      })
      .addCase(postFeed.rejected, (state, action) => {
        console.log("action rejected post feed api", action?.payload);
      })
      .addCase(updateFeed.pending, (state, action) => {
        console.log("action pending update feed api");
      })
      .addCase(updateFeed.fulfilled, (state, action) => {
        console.log("action fulfilled update feed api");
      })
      .addCase(updateFeed.rejected, (state, action) => {
        console.log("action rejected update feed api", action?.payload);
      })
      .addCase(deleteFeed.fulfilled, (state, action) => {
        console.log("action fulfilled delete feed api");
      })
      .addCase(deleteFeed.rejected, (state, action) => {
        console.log("action rejected delete feed api", action?.payload);
      })
      .addCase(likeFeed.fulfilled, (state, action) => {
        console.log("action fulfilled like feed api", action);
      })
      .addCase(likeFeed.rejected, (state, action) => {
        console.log("action rejected like feed api", action?.payload);
      })
      .addCase(postFeedComment.fulfilled, (state, action) => {
        console.log("action fulfilled feed post comment api", action);
      })
      .addCase(postFeedComment.rejected, (state, action) => {
        console.log("action rejected feed post comment api", action?.payload);
      })
      .addCase(postFeedCommentReplay.fulfilled, (state, action) => {
        console.log("action fulfilled feed post comment replay api", action);
      })
      .addCase(postFeedCommentReplay.rejected, (state, action) => {
        console.log(
          "action rejected feed post comment replay api",
          action?.payload
        );
      })
      .addCase(updateFeedComment.fulfilled, (state, action) => {
        console.log("action fulfilled feed update comment api", action);
      })
      .addCase(updateFeedComment.rejected, (state, action) => {
        console.log("action rejected feed update comment api", action?.payload);
      })
      .addCase(updateFeedCommentReplay.fulfilled, (state, action) => {
        console.log("action fulfilled feed update comment replay api", action);
      })
      .addCase(updateFeedCommentReplay.rejected, (state, action) => {
        console.log(
          "action rejected feed update comment replay api",
          action?.payload
        );
      })
      .addCase(deleteFeedComment.fulfilled, (state, action) => {
        console.log("action fulfilled feed delete comment api", action);
      })
      .addCase(deleteFeedComment.rejected, (state, action) => {
        console.log("action rejected feed delete comment api", action?.payload);
      })
      .addCase(deleteFeedCommentReplay.fulfilled, (state, action) => {
        console.log("action fulfilled feed delete comment Replay api", action);
      })
      .addCase(deleteFeedCommentReplay.rejected, (state, action) => {
        console.log(
          "action rejected feed delete comment Replay api",
          action?.payload
        );
      })
      .addCase(updateFeedCommentLikes.fulfilled, (state, action) => {
        console.log("action fulfilled update comment likes api");
      })
      .addCase(updateFeedCommentLikes.rejected, (state, action) => {
        console.log(
          "action rejected update comment likes api",
          action?.payload
        );
      })
      .addCase(updateFeedCommentReplayLikes.fulfilled, (state, action) => {
        console.log("action fulfilled update comment Replay likes api");
      })
      .addCase(updateFeedCommentReplayLikes.rejected, (state, action) => {
        console.log(
          "action rejected update comment Replay likes api",
          action?.payload
        );
      })

      .addCase(postEvent.pending, (state, action) => {
        console.log("action pending post event api");
      })
      .addCase(postEvent.fulfilled, (state, action) => {
        console.log("action fulfilled post event api");
      })
      .addCase(postEvent.rejected, (state, action) => {
        console.log("action rejected post event api", action?.payload);
      })

      .addCase(updateEvent.pending, (state, action) => {
        console.log("action pending Update event api");
      })
      .addCase(updateEvent.fulfilled, (state, action) => {
        console.log("action fulfilled Update event api");
      })
      .addCase(updateEvent.rejected, (state, action) => {
        console.log("action rejected Update event api", action?.payload);
      })

      .addCase(getAllEvents.pending, (state, action) => {
        console.log("action pending get event api");
      })
      .addCase(getAllEvents.fulfilled, (state, action) => {
        console.log("action fulfilled get evnt api");
        const page = action?.payload?.pagination?.page;
        state.events =
          page > 0
            ? [...state?.events, ...action?.payload?.data]
            : action?.payload?.data;
      })
      .addCase(getAllEvents.rejected, (state, action) => {
        console.log("action rejected get event api", action?.payload);
      })
      .addCase(getMyEvents.pending, (state, action) => {
        console.log("action pending get my event api");
      })
      .addCase(getMyEvents.fulfilled, (state, action) => {
        const page = action?.payload?.pagination?.page;
        state.myEvents = {
          data: page > 0
            ? [...(state.myEvents.data || []), ...action.payload.data]
            : action.payload.data,
          pagination: action.payload.pagination
        };
      })
      .addCase(getMyEvents.rejected, (state, action) => {
        console.log("action rejected get my event api", action?.payload);
      })
      .addCase(getSingleEvent.pending, (state, action) => {
        console.log("action pending get single event api");
      })
      .addCase(getSingleEvent.fulfilled, (state, action) => {
        console.log("action fulfilled get evnt api");
        const page = action?.payload?.pagination?.page;
        state.singleEvent =
          page > 0
            ? [...state?.events, ...action?.payload?.data]
            : action?.payload?.data;
      })
      .addCase(getSingleEvent.rejected, (state, action) => {
        console.log("action rejected get single event api", action?.payload);
      })
      .addCase(deleteEvent.fulfilled, (state, action) => {
        console.log("action fulfilled feed delete event api", action);
      })
      .addCase(deleteEvent.rejected, (state, action) => {
        console.log("action rejected feed delete event api", action?.payload);
      })
      .addCase(RegisterEvent.pending, (state, action) => {
        console.log("action pending register event api");
      })
      .addCase(RegisterEvent.fulfilled, (state, action) => {
        console.log("action fulfilled register event api");
      })
      .addCase(RegisterEvent.rejected, (state, action) => {
        console.log("action rejected register event api", state);
      })
      .addCase(getEventAttendees.pending, (state, action) => {
        console.log("action pending get events attendess api");
      })
      .addCase(getEventAttendees.fulfilled, (state, action) => {
        console.log("action fulfilled get events attendess api");
        state.EventAttendees = action?.payload?.data;
      })
      .addCase(getEventAttendees.rejected, (state, action) => {
        console.log(
          "action rejected get events attendess api",
          action?.payload
        );
      })
      .addCase(getRegisteredAttendees.pending, (state, action) => {
        console.log("action pending get events attendess api");
      })
      .addCase(getRegisteredAttendees.fulfilled, (state, action) => {
        console.log("action fulfilled get events attendess api");
        state.registeredAttendees = action?.payload?.data;
      })
      .addCase(getRegisteredAttendees.rejected, (state, action) => {
        console.log(
          "action rejected get events attendess api",
          action?.payload
        );
      })
      .addCase(getRegisteredAttendeesHistory.pending, (state, action) => {
        console.log("action pending get events attendess api");
      })
      .addCase(getRegisteredAttendeesHistory.fulfilled, (state, action) => {
        console.log("action fulfilled get events attendess api");
        state.registeredAttendeesHistory = action?.payload?.data;
      })
      .addCase(getRegisteredAttendeesHistory.rejected, (state, action) => {
        console.log(
          "action rejected get events attendess api",
          action?.payload
        );
      })
      .addCase(transferTicket.pending, (state, action) => {
        console.log("action pending transerfer ticket api");
      })
      .addCase(transferTicket.fulfilled, (state, action) => {
        console.log("action fulfilled transerfer ticket api");
      })
      .addCase(transferTicket.rejected, (state, action) => {
        console.log("action rejected transerfer ticket api", action?.payload);
      })
      .addCase(cancelTicket.pending, (state, action) => {
        console.log("action pending cancel ticket api");
      })
      .addCase(cancelTicket.fulfilled, (state, action) => {
        console.log("action fulfilled cancel ticket api");
      })
      .addCase(cancelTicket.rejected, (state, action) => {
        console.log("action rejected cancel ticket api", action?.payload);
      })
      .addCase(getAttendeeAccessPass.pending, (state, action) => {
        console.log("action pending get events attendess api");
      })
      .addCase(getAttendeeAccessPass.fulfilled, (state, action) => {
        console.log("action fulfilled get events attendess api");
        state.attendeeAcessPass = action?.payload?.data;
      })
      .addCase(getAttendeeAccessPass.rejected, (state, action) => {
        console.log(
          "action rejected get events attendess api",
          action?.payload
        );
      })
      .addCase(getExplore.pending, (state, action) => {
        console.log("action pending get events attendess api");
      })
      .addCase(getExplore.fulfilled, (state, action) => {
        const { data: newData, meta } = action.payload;
        const existingData = state.exploreAllFeeds?.data || [];
        const hasCursor = action.meta.arg?.cursor;

        // Create a map of existing items for quick lookup
        const existingItemsMap = new Map(existingData.map(item => [item.id, item]));

        // Merge data - update existing items and add new ones
        const mergedData = hasCursor
          ? [
            ...existingData.map(item => {
              // If item exists in new data, use the new version
              const newItem = newData.find(newItem => newItem.id === item.id);
              return newItem || item;
            }),
            // Add items that don't exist in existing data
            ...newData.filter(newItem => !existingItemsMap.has(newItem.id))
          ]
          : newData;

        state.exploreAllFeeds = {
          data: mergedData,
          meta,
          loading: false
        };
      })
      .addCase(getExplore.rejected, (state, action) => {
        console.log(
          "action rejected get events attendess api",
          action?.payload
        );
      })
      .addCase(PostInvaiteUsersToEvent.pending, (state, action) => {
        console.log("action pending post Invite users to event api");
      })
      .addCase(PostInvaiteUsersToEvent.fulfilled, (state, action) => {
        console.log("action fulfilled post Invite users to event api");
      })
      .addCase(PostInvaiteUsersToEvent.rejected, (state, action) => {
        console.log("action rejected post Invite users to event api", action?.payload);
      })
      .addCase(removeUsersFromInvaite.pending, (state, action) => {
        console.log("action pending remove users from invaite api");
      })
      .addCase(removeUsersFromInvaite.fulfilled, (state, action) => {
        console.log("action fulfilled remove users from invaite api");
      })
      .addCase(removeUsersFromInvaite.rejected, (state, action) => {
        console.log("action rejected remove users from invaite api", action?.payload);
      })
      .addCase(getInvaiteUsersEvent.pending, (state, action) => {
        console.log("action pending get invaite user event api");
      })
      .addCase(getInvaiteUsersEvent.fulfilled, (state, action) => {
        console.log("action fulfilled get invaite user event api");
        state.getInviteUserEvent = action?.payload?.data;
      })
      .addCase(getInvaiteUsersEvent.rejected, (state, action) => {
        console.log(
          "action rejected get invaite user event api",
          action?.payload
        );
      })
      .addCase(getEventAnalytics.pending, (state, action) => {
        console.log("action pending get event analytics api");
      })
      .addCase(getEventAnalytics.fulfilled, (state, action) => {
        console.log("action fulfilled get event analytics api");
        state.eventAnalytics = action?.payload?.data;
      })
      .addCase(getEventAnalytics.rejected, (state, action) => {
        console.log(
          "action rejected get event analytics api",
          action?.payload
        );
      })
      .addCase(getVolunteers.pending, (state, action) => {
        console.log("action pending get event volunteers api");
      })
      .addCase(getVolunteers.fulfilled, (state, action) => {
        console.log("action fulfilled get event volunteers api");
        state.VolunteersData = action?.payload?.data;
      })
      .addCase(getVolunteers.rejected, (state, action) => {
        console.log(
          "action rejected get volunteers api",
          action?.payload
        );
      })
      .addCase(getVolunteerById.pending, (state, action) => {
        console.log("action pending get volunteer by id api");
      })
      .addCase(getVolunteerById.fulfilled, (state, action) => {
        console.log("action fulfilled get volunteer by id api");
        state.VolunteerByIdData = action?.payload?.data;
      })
      .addCase(getVolunteerById.rejected, (state, action) => {
        console.log(
          "action rejected get volunteer by id api",
          action?.payload
        );
      })
      .addCase(getEventAccessLogs.pending, (state, action) => {
        console.log("action pending get volunteer by id api");
      })
      .addCase(getEventAccessLogs.fulfilled, (state, action) => {
        console.log("action fulfilled get volunteer by id api");
        state.geteventaccessbyId = action?.payload?.data;
      })
      .addCase(getEventAccessLogs.rejected, (state, action) => {
        console.log(
          "action rejected get volunteer by id api",
          action?.payload
        );
      })
      .addCase(deleteVolunteer.pending, (state, action) => {
        console.log("action pending get volunteer by id api");
      })
      .addCase(deleteVolunteer.fulfilled, (state, action) => {
        console.log("action fulfilled get volunteer by id api");
      })
      .addCase(deleteVolunteer.rejected, (state, action) => {
        console.log(
          "action rejected get volunteer by id api",
          action?.payload
        );
      })
  },
});

export const { setFeeds, setExploreType } = communitySlice.actions;
export default communitySlice.reducer;
